"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerMINIComponent = void 0;
var core_1 = require("@angular/core");
var footerMINIComponent = /** @class */ (function () {
    function footerMINIComponent() {
    }
    footerMINIComponent.prototype.ngOnInit = function () {
    };
    footerMINIComponent = __decorate([
        core_1.Component({
            selector: 'app-footer-mini',
            template: require('./footer-mini.component.html')
        }),
        __metadata("design:paramtypes", [])
    ], footerMINIComponent);
    return footerMINIComponent;
}());
exports.footerMINIComponent = footerMINIComponent;
